import * as Yup from "yup";

export function getAuthInitialValues(obj) {
  let rememberMe = false
  if(obj?.rememberMe === "true"){
    rememberMe= true
  }
  return {
    email: obj?.email || "",
    password: obj?.password || "",
    rememberMe: rememberMe,
  };
}

const VALIDATION_SCHEMA = (locale) => Yup.object().shape({
  email: Yup.string()
    .email(locale('invalidEmail')).required(locale('emailRequired')),
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int){1}$/,"Please enter a valid email."),
  password: Yup.string()
    .label(locale('password'))
    .required(locale('passwordRequired'))
    .matches(/[a-z]+/, locale('passwordLowercase'))
    .matches(/[A-Z]+/, locale('passwordUppercase'))
    .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, locale('passwordSymbol'))
    .matches(/\d+/,  locale('passwordNumber'))
    .min(8,  locale('passwordMinLength'))
    .max(20,  locale('passwordMaxLength')),
});

export { VALIDATION_SCHEMA };
